import React from 'react';

const WHATSAPP_LINK = "https://wa.me/918180064540";

// Footer column data
const learnLinks = [
  { label: 'About Us', href: '#' },
  { label: 'Science & Research', href: '#' },
  { label: 'Blog', href: '#' },
];

const accessLinks = [
  { label: 'Peptide', href: '#' },
  { label: 'Supplement', href: '#' },
  { label: 'Diet Fuel', href: '#' },
];

const connectLinks = [
  { label: 'Contact', href: '#' },
  { label: 'Support', href: '#' },
  { label: 'WhatsApp', href: WHATSAPP_LINK },
];

const bottomLinks = [
  { label: 'Disclaimer', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms & Conditions', href: '#' },
];

const DISCLAIMER_TEXT = "These products are not intended to diagnose, treat, cure, or prevent any disease. The information provided on this website is for educational and informational purposes only and is not intended as medical advice. Always consult with a qualified healthcare professional before starting any new supplement, peptide protocol, or health program, especially if you have a medical condition, are taking prescription medications, or are pregnant or nursing. The company does not make any guarantees regarding the outcomes of using its products or protocols. Individual results may vary based on biological factors, lifestyle, and adherence to recommended usage. The use of peptides and supplements should be approached responsibly and under appropriate guidance. By using this website and purchasing products, you acknowledge that you are doing so at your own discretion and risk. The company shall not be held liable for any direct, indirect, incidental, or consequential damages arising from the use or misuse of its products or the information provided.";

export const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      className="w-full relative overflow-hidden"
      style={{ backgroundColor: '#1A3D36' }}
    >
      {/* Large Background Text */}
      <div 
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden"
        style={{ opacity: 0.03 }}
      >
        <span 
          className="font-serif font-bold text-[180px] lg:text-[280px] tracking-widest whitespace-nowrap"
          style={{ color: '#FFFFFF' }}
        >
          LONGEVITY
        </span>
      </div>

      {/* Divider Line */}
      <div 
        className="w-full h-px"
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
      />

      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1">
            <h3 
              className="font-serif text-xl font-semibold mb-4"
              style={{ color: '#E8E6E1' }}
            >
              Life Reversal
            </h3>
            <p 
              className="text-sm leading-relaxed"
              style={{ color: '#8A9B90' }}
            >
              Precision-based longevity systems designed to optimize human biology through structured protocols.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-4 mt-6">
              {/* Instagram */}
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-70"
                data-testid="social-instagram"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E8E6E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              {/* YouTube */}
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="transition-opacity hover:opacity-70"
                data-testid="social-youtube"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E8E6E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2: Learn */}
          <div>
            <h4 
              className="text-xs font-medium uppercase tracking-wider mb-5"
              style={{ color: '#E8E6E1', letterSpacing: '0.1em' }}
            >
              Learn
            </h4>
            <ul className="space-y-3">
              {learnLinks.map((link, idx) => (
                <li key={idx}>
                  <a 
                    href={link.href}
                    className="text-sm transition-opacity hover:opacity-70"
                    style={{ color: '#8A9B90' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Access */}
          <div>
            <h4 
              className="text-xs font-medium uppercase tracking-wider mb-5"
              style={{ color: '#E8E6E1', letterSpacing: '0.1em' }}
            >
              Access
            </h4>
            <ul className="space-y-3">
              {accessLinks.map((link, idx) => (
                <li key={idx}>
                  <a 
                    href={link.href}
                    className="text-sm transition-opacity hover:opacity-70"
                    style={{ color: '#8A9B90' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div>
            <h4 
              className="text-xs font-medium uppercase tracking-wider mb-5"
              style={{ color: '#E8E6E1', letterSpacing: '0.1em' }}
            >
              Connect
            </h4>
            <ul className="space-y-3">
              {connectLinks.map((link, idx) => (
                <li key={idx}>
                  <a 
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : undefined}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="text-sm transition-opacity hover:opacity-70"
                    style={{ color: '#8A9B90' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimer Section */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pb-10">
        <div 
          className="pt-8"
          style={{ borderTop: '1px solid rgba(255, 255, 255, 0.08)' }}
        >
          <h5 
            className="text-[10px] font-medium uppercase tracking-wider mb-3"
            style={{ color: '#6B7D73', letterSpacing: '0.12em' }}
          >
            Disclaimer
          </h5>
          <p 
            className="text-[11px] leading-[1.6]"
            style={{ color: '#5A6B62' }}
          >
            {DISCLAIMER_TEXT}
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div 
        className="relative z-10"
        style={{ borderTop: '1px solid rgba(255, 255, 255, 0.08)' }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Left: Copyright */}
            <p 
              className="text-xs"
              style={{ color: '#5A6B62' }}
            >
              © 2026 Life Reversal. All rights reserved
            </p>

            {/* Right: Links */}
            <div className="flex items-center gap-6">
              {bottomLinks.map((link, idx) => (
                <a 
                  key={idx}
                  href={link.href}
                  className="text-xs transition-opacity hover:opacity-70"
                  style={{ color: '#5A6B62' }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
